import { axiosInstance } from '../../../common/api';

export const registrationAccount = (data) => ({ type: "REGISTRATION", payload: axiosInstance.post('auth/signup', data) }); 